import {
  FieldsGroup,
  TabItem,
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import emailMenuFieldsConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-menu-fields-config';

const getWidgetMenuConfig = (templateType: TemplateParentTypeEnum, isV4 = false): WidgetTypeConfig => {
  let fieldItems: Array<FieldsGroup | TabItem> = [];
  switch (templateType) {
    default:
      fieldItems = isV4 ? emailMenuFieldsConfigV4 : [];
  }
  return {
    tabPanel: {
      label: 'templateBuilder.widgetsHeaders.menu',
      items: fieldItems,
    },
  };
};

export default getWidgetMenuConfig;
